export default __webpack_public_path__ + "static/media/R.6ff93b05.svg";